import { classnames } from '@bem-react/classnames';
import { withBemMod } from '@bem-react/core';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelQuote } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_quote.css';

export interface ILevelTypeQuoteProps extends Omit<ILevelQuote, 'type'> {
    type?: 'quote';
}

export const withLevelTypeQuote = withBemMod<ILevelTypeQuoteProps, ILevelProps>(
    cnLevel(),
    { type: 'quote' },
    (BaseLevel: React.FC<ILevelProps>) => props => {

        const { imageSrc, name, info, text, className: baseClassName, ...otherProps } = props;

        const levelTypeQuoteMods = imageSrc ? {} : { image: 'no' };
        const className = classnames(
            baseClassName,
            cnLevel('', levelTypeQuoteMods)
        );

        return (
            <BaseLevel className={className} {...otherProps}>
                <>
                    <div className={cnLevel('human')}>
                        {imageSrc && (
                            <img className={cnLevel('human-photo')} src={imageSrc} alt={name} />
                        )}
                        <div className={cnLevel('human-info')}>
                            <div className={cnLevel('human-name')} title={name}>{name}</div>
                            <HtmlContent className={cnLevel('human-description')} content={info} />
                        </div>
                    </div>
                    <HtmlContent className={cnLevel('text')} tag="div" content={text} />
                </>
            </BaseLevel>
        );
    }
);
